import logoDark from 'assets/img/logo.dark.png';
import logoLight from 'assets/img/logo.light.png';
import withColorQuery, { WithColorQueryProps } from 'enhancers/withColorQuery';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import * as React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface IProps {
  color: string;
  className?: string;
}

type Props = IProps & IWithCountryProps & WithColorQueryProps;

export const CountryLogo: React.SFC<Props> = props => {
  const image = props.color === '#ffffff' ? logoLight : logoDark;
  const siteImage =
    !props.loading &&
    props.data &&
    props.data.fetch.Country.Navbar &&
    props.data.fetch.Country.Navbar.Logo
      ? props.data.fetch.Country.Navbar.Logo.src
      : '';

  return (
    <Link to="/">
      <Image className={props.className} src={siteImage || image} alt="logo" />
    </Link>
  );
};

const Image = styled.img`
  width: 70px;
`;

export default withCountry(withColorQuery(CountryLogo));



// WEBPACK FOOTER //
// ./src/components/CountryLogo/CountryLogo.tsx